import React from "react";
import { AppRouteProps } from "@harea/component";

const SubscriptionRenewContainer = React.lazy(() => import("./container/SubscriptionRenewContainer"));

export const SubscriptionRenewRoutes: Array<AppRouteProps> = [
    {
        path: "subscription/renew",
        title: "std_renew_subscription",
        element: <SubscriptionRenewContainer />,
        roles: ["RENEW_SUBSCRIPTION"],
    },
];